interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Keep the outlet and portal shells stable. The router alone restores scroll
 * after the destination renders: location changes can precede outlet commits,
 * so scrolling or fading here would affect the outgoing page.
 */
const PageTransition = ({ children }: PageTransitionProps) => {
  return <div>{children}</div>;
};

export default PageTransition;
